"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HUB = {
  participantId: 'firebase:simple-hub'
};